import React from "react";

/** Bottom toast: a status message with an optional Undo, or an error announced as an alert. */
export default function Notice({ notice, onUndo }) {
  if (!notice) return null;
  const error = notice.kind === "error";
  return (
    <div className={`toast${error ? " err" : ""}`} role={error ? "alert" : "status"}>
      <span>{notice.message}</span>
      {notice.undo && <button type="button" onClick={onUndo}>Undo</button>}
    </div>
  );
}
